import { createContext, useContext } from 'react';
import Workspace from '../../../types/Workspace';

type LayoutContextType = {
  collapsed: boolean;
  selectedSpace?: Workspace;
};

export const LayoutContext = createContext<LayoutContextType | undefined>(undefined);

export const useLayoutContext = () => {
  const context = useContext(LayoutContext);
  return context;
};
